export const getPrivateStatsProjectName = (
  token: string,
  unmaskedCharsCount = 3,
) =>
  `${token.slice(0, unmaskedCharsCount)}*****${token.slice(
    -unmaskedCharsCount,
  )}`;
